'use client';

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { Button, Sheet, SheetClose, SheetContent, SheetDescription, SheetTitle } from '@repo/ui';
export interface BottomSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  /** Shown at the end of the title row, e.g. a total. */
  aside?: ReactNode;
  children: ReactNode;
}

/**
 * Touch replacement for a hover tooltip: a sheet anchored to the bottom edge with the label as
 * title, the explanation as body and a full-width Close button. Headless otherwise — callers
 * decide when to show it (typically on `(hover: none)` pointers).
 */
export function BottomSheet(t0) {
  const $ = _c(17);
  const {
    open,
    onOpenChange,
    title,
    aside,
    children
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <SheetTitle className="text-title-xs text-foreground font-normal">{title}</SheetTitle>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== aside) {
    t2 = aside && <span className="text-foreground text-sm">{aside}</span>;
    $[2] = aside;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="gap-sm flex items-baseline justify-between">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== children) {
    t4 = <SheetDescription asChild={true}><div className="text-secondary-foreground text-xs">{children}</div></SheetDescription>;
    $[7] = children;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <SheetClose asChild={true}><Button variant="secondary" size="md" fullWidth={true}>Close</Button></SheetClose>;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t3 || $[11] !== t4) {
    t6 = <SheetContent side="bottom" className="bg-card gap-md px-md pt-md pb-lg rounded-t-[20px] border-t-0 [&>button.absolute]:hidden">{t3}{t4}{t5}</SheetContent>;
    $[10] = t3;
    $[11] = t4;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== onOpenChange || $[14] !== open || $[15] !== t6) {
    t7 = <Sheet open={open} onOpenChange={onOpenChange}>{t6}</Sheet>;
    $[13] = onOpenChange;
    $[14] = open;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
}